import React from 'react';

const ZpHeadReports = () => {
    return (
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
            <h2 className="text-3xl font-bold text-[#1a1a4d]">सर्व रिपोर्ट</h2>
            <p className="text-gray-500 mt-2">विविध प्रकारचे अहवाल आणि विश्लेषण.</p>
            <div className="mt-8 border-t border-gray-100 pt-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {['अभियंता अहवाल', 'संस्था अहवाल', 'कामांचा प्रगती अहवाल', 'आर्थिक अहवाल'].map((item, i) => (
                        <button key={i} className="flex items-center justify-between p-6 rounded-xl border border-gray-200 hover:border-[#0091ea] hover:bg-blue-50 transition-all text-left">
                            <span className="font-bold text-gray-700">{item}</span>
                            <span className="text-[#0091ea] font-medium">पहा →</span>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ZpHeadReports;
